module.exports = __webpack_public_path__ + "img/Jump Casting59.9203dca8.jpg";